import type { ExpressionSpecification } from 'mapbox-gl';

export const ZONE_TYPES = ['H', 'R', 'UH'] as const;
export type ZoneType = (typeof ZONE_TYPES)[number];

/** Shared by territories, clusters, selected marks and filter swatches — never ownership. */
export const ZONE_TYPE_COLORS = {
  H: '#096CDC',
  R: '#00A36D',
  UH: '#7C3AED',
} as const;

/** Mirrors the tile queries' name classification for selected GeoJSON, which does not come from tiles. */
export function zoneTypeFromName(name: string = ''): ZoneType {
  const parts = name.split('-');
  const code = parts.length >= 3 && parts[0] ? parts[1].trim().toUpperCase() : '';
  return code === 'R' || code === 'UH' ? code : 'H';
}

/** New tiles carry zone_type. The name fallback keeps older outline tiles usable during rollout. */
export function zoneTypeExpression(): ExpressionSpecification {
  return [
    'coalesce',
    ['get', 'zone_type'],
    [
      'let',
      'parts',
      ['split', ['upcase', ['coalesce', ['get', 'name'], '']], '-'],
      [
        'match',
        [
          'case',
          [
            'all',
            ['>=', ['length', ['var', 'parts']], 3],
            ['>', ['length', ['at', 0, ['var', 'parts']]], 0],
          ],
          ['at', 1, ['var', 'parts']],
          '',
        ],
        ['R', ' R', 'R ', ' R '],
        'R',
        ['UH', ' UH', 'UH ', ' UH '],
        'UH',
        'H',
      ],
    ],
  ];
}
